import { Injectable, computed, signal } from '@angular/core';

const INITIAL_PAGE_INDEX = 0;
const INITIAL_PAGE_SIZE = 10;
const INITIAL_TOTAL_ITEMS = 0;

@Injectable()
export class PaginationStore {

  readonly pageIndexSignal = signal<number>(INITIAL_PAGE_INDEX);
  readonly pageSizeSignal = signal<number>(INITIAL_PAGE_SIZE);
  readonly totalItemsSignal = signal<number>(INITIAL_TOTAL_ITEMS);

  readonly totalPagesSignal = computed(() => Math.max(1, Math.ceil(this.totalItemsSignal() / this.pageSizeSignal())));
  readonly pageOffsetSignal = computed(() => this.pageIndexSignal() * this.pageSizeSignal());

  setTotalItems(total: number): void {
    this.totalItemsSignal.set(total);
  }

  resetPageIndex(): void {
    this.pageIndexSignal.set(0);
  }

  getPagedData<T extends object>(data: readonly T[]): readonly T[] {
    const size = this.pageSizeSignal();
    const pageCount = Math.max(1, Math.ceil(data.length / size));
    const safeIndex = Math.min(this.pageIndexSignal(), pageCount - 1);
    const start = safeIndex * size;
    return data.slice(start, start + size);
  }
}
